// Libs
import React from 'react'
import ReactSVG from 'react-svg'

// CSS
import './styles.scss'

// Components
import Button from '../../../../components/Button'
import Modal from '../../../../components/Modal'

//SVG
import semProcessoLogo from '../../../../assets/capture/semProcessoLogo.svg'
import eLawLogo from '../../../../assets/capture/eLawLogo.svg'
import bennerLogo from '../../../../assets/capture/bennerLogo.svg'
// import legalOneLogo from '../../../../assets/capture/legalOneLogo.svg'

const CaptureExport = ({ visible, exportModelSelected, changeVisible, changeExportModelSelected, exportModel, loading, exportCases }) => {

  const exportTypes = [{ label: "Com Acordo", logo: semProcessoLogo, available: true },
  { label: "eLaw", logo: eLawLogo, available: false },
    // {label: "benner", logo: bennerLogo, available: false}
    // {label: "legalOne", logo: legalOneLogo, avaiable: false}
  ]

  return (
    <Modal visible={visible} handleClose={() => changeVisible("_export", false)}>
      <div className="capture-export">
        <div className="capture-export__title">
          Exportar
        </div>
        <div className="capture-export__subtitle">
          Escolha abaixo em qual modelo deseja exportar a planilha com {(exportCases === "all") ? 'os seus casos' : 'o seu caso'}
        </div>
        <div className="capture-export__grid">
          {exportTypes.map(item => {
            return (
              <span
                className={
                  (item.available) ?
                    ((item.label === exportModelSelected) ? "capture-export__model capture-export__model--selected" : "capture-export__model") :
                    "capture-export__model capture-export__model--unavailable"}
                key={item.label}
                onClick={() => (item.available) ? changeExportModelSelected(item.label) : ''}
              >
                <span></span>
                <span><ReactSVG src={item.logo} /></span>
                <span>{(item.available) ? "" : "Em breve"}</span>
              </span>
            )
          })}
        </div>
        <div className="capture-export__button--wrapper">
          <Button onClick={() => changeVisible("_export", false)}>
            Voltar
          </Button>
          <Button
            type="submit"
            localLoading={loading}
            disabled={(!exportModelSelected) ? true : false}
            onClick={() => exportModel(exportModelSelected, exportCases)}>
            Exportar
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default CaptureExport
